import parseHTML from "../../lib/dom/funciones/parse_html";
const desplazadorDeTestimonios = (linea, direccion) => {
    const elemento = linea.querySelector('li:nth-child(2)');
    return () => linea.scroll({
        left: linea.scrollLeft + direccion * elemento.offsetLeft,
        behavior: 'smooth'
    });
};
const testimonios = () => {
    Array.from(document.querySelectorAll('.bloque--testimonios')).forEach((el) => {
        const anterior = parseHTML('<button class="linea_de_tiempo__anterior" disabled>Anterior</button>'), siguiente = parseHTML('<button class="linea_de_tiempo__siguiente">Siguiente</button>'), navegacion = parseHTML('<div class="linea_de_tiempo__navegacion"></div>');
        navegacion.appendChild(anterior);
        navegacion.appendChild(siguiente);
        el.appendChild(navegacion);
        const lista = el.querySelector('ul');
        anterior.addEventListener('click', desplazadorDeTestimonios(lista, -1));
        siguiente.addEventListener('click', desplazadorDeTestimonios(lista, 1));
        lista.addEventListener('scroll', () => {
            anterior.disabled = lista.scrollLeft === 0;
            siguiente.disabled = Math.abs(lista.scrollLeft + lista.clientWidth - lista.scrollWidth) < 2;
        });
        const videos = Array.from(el.querySelectorAll('video'));
        videos.forEach((video) => {
            video.controls = false;
            const videoGrande = parseHTML('<div class="video-grande"></div>');
            videoGrande.addEventListener('click', e => {
                if (e.target === videoGrande) {
                    cierraVideo();
                }
            });
            videoGrande.addEventListener('transitionend', () => {
                if (getComputedStyle(videoGrande).opacity === '0') {
                    videoGrande.remove();
                }
            });
            const cierraVideo = () => {
                videoGrande.style.opacity = '0';
            };
            const abreVideo = function (e) {
                document.body.appendChild(videoGrande);
                const clon = video.cloneNode(true);
                clon.controls = true;
                videoGrande.innerHTML = '';
                videoGrande.appendChild(clon);
                videoGrande.style.opacity = '0';
                clon.addEventListener('pause', cierraVideo);
                requestAnimationFrame(() => {
                    clon.play();
                    videoGrande.style.opacity = '1';
                });
                e.preventDefault();
            };
            video.addEventListener('click', abreVideo);
        });
    });
};
export default testimonios;
